export interface IStorage {
    get: (key: string) => unknown;
    set: (key: string, value: unknown) => void;
}

const GLOBAL_KEY = '__STORAGE_UI_COMMON';
const DEFAULT_DOMAIN = 'default';

function _buildGlobalStorage(globalKey: string) {
    const globalObject: Record<string, unknown> =
        typeof window === 'undefined' ? globalThis : window;
    const storageObject =
        (globalObject[globalKey] as Record<string, Record<string, unknown>> | undefined) ?? {};
    globalObject[globalKey] = storageObject;

    return {
        get: (key: string) => {
            const storage = storageObject[key] ?? {};
            storageObject[key] = storage;
            return storage;
        },
        update: (key: string, value: Record<string, unknown>) => {
            storageObject[key] = value;
        },
    };
}

const globalStorage = _buildGlobalStorage(GLOBAL_KEY);

function builder(domain: string = DEFAULT_DOMAIN): Readonly<IStorage> {
    return Object.freeze({
        get: (key: string) => {
            const storage = globalStorage.get(domain);
            return storage[key];
        },
        set: (key: string, value: unknown) => {
            const storage = globalStorage.get(domain);
            storage[key] = value;
            globalStorage.update(domain, storage);
        },
    });
}

export default builder;
